import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVentSilencer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 80,
	viewBox: "0 0 19.0 80.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 2.0 0.0 L 17.0 10.0 L 17.0 80.0 L 2.0 80.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 25,
		width: 19,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgVentSilencer;
